import React, {useState} from "react";
import { FaListUl, FaMapSigns, FaUserEdit} from "react-icons/fa";
import {Button} from "antd";
import {RiUser3Fill} from "react-icons/ri";
import {FormEditProfile} from "./formEditProfile";
import {UserActivity} from "./userActivity";
import {UserProfileInformation} from "./userProfileInformation";
import useWindowViewport from "../../hooks/useWindowViewport";

export const ProfileUser = ({genderIdentityCatalog,profileInfo,handleUpdateProfile}) => {
    const [activeTab, setActiveTab] = useState("1");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [typeForm, setTypeForm] = useState("");
    const {windowWidth} = useWindowViewport();

    const showFormUserProfile = (value,typeForm = "") => {
        setIsModalOpen(value);
        setTypeForm(typeForm)
    };

    return (
        <article className="container-page">
            <div className={"profile__user"}>
                <div className={"profile__user-info"}>
                    <div className={"profile__user-info__top"}>
                        <h2>Mi perfil</h2>
                        <Button icon={<FaUserEdit />} type={"primary"} htmlType={"button"} color={"primary"} onClick={() => showFormUserProfile(true,"user")} />
                    </div>
                    <div className={"profile__user-info__content"}>
                        <UserProfileInformation profileInfo={profileInfo} />
                    </div>
                    <div className={"profile__user-info__bottom"}>
                        <ul>
                            <li>
                                <Button
                                    htmlType={"button"}
                                    type={"secondary"}
                                    onClick={() => setActiveTab("1")}
                                    className={activeTab === "1" ? "active" : ""}
                                    icon={<FaListUl />}
                                >
                                    Actividades del usuario
                                </Button>
                            </li>
                            <li>
                                <Button
                                    htmlType={"button"}
                                    type={"secondary"}
                                    onClick={() => setActiveTab("2")}
                                    className={activeTab === "2" ? "active" : ""}
                                    icon={<FaMapSigns />}
                                >
                                    Servicios publicados
                                </Button>
                            </li>
                            <li>
                                <Button
                                    htmlType={"button"}
                                    type={"secondary"}
                                    onClick={() => setActiveTab("3")}
                                    className={activeTab === "3" ? "active" : ""}
                                    icon={<RiUser3Fill />}
                                >
                                    Mis postulaciones
                                </Button>
                            </li>
                        </ul>
                    </div>
                </div>
                {
                    (windowWidth < 992) && (
                        <div className={"profile__tables"}>
                            <UserActivity activeTab={activeTab} />
                        </div>
                    )
                }
                <div className={"profile__user-flag"}>
                    <h2>Mi Bandera</h2>
                    <div className={"my-flag"}>
                        <span role={"contentinfo"}>{profileInfo?.genderName}</span>
                        <div className={`flag ${profileInfo?.genderIdentityFlag}`}></div>
                        <Button htmlType={"button"} type={"primary"} block={true} onClick={() => showFormUserProfile(true,"myFlag")}>Cambiar mi bandera</Button>
                    </div>
                </div>
            </div>
            {
                (windowWidth > 992) && (
                    <div className={"profile__tables"}>
                        <UserActivity activeTab={activeTab} />
                    </div>
                )
            }
            <FormEditProfile
                isModalOpen={isModalOpen}
                showFormUserProfile={showFormUserProfile}
                typeForm={typeForm}
                profileInfo={profileInfo}
                handleUpdateProfile={handleUpdateProfile}
                genderIdentityCatalog={genderIdentityCatalog}
            />
        </article>
    );
}